

export default function RedirectPage() {
    console.log("Redirect page called")
    window.location.replace('https://prwire360.com/auth/login');
    return null;
}